import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  INITIATED,
  NIUM_FOREX_URL_SEND_MONEY,
  POST_LOGOUT_URL,
  REGISTERED,
  SERVICE_UNAVAILABLE_MODAL_TEXT
} from '../../utils/constants';
import PropTypes from 'prop-types';
import DEVICES from '../../common/styles/devices';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { logoutRequest } from '../../redux/actions/authentication/authentication-action';
import COLORS from '../../common/styles/color-pallete';
import { FOREX_ALLOWED_PIN_CODES } from '../../redux/action-contants';
import { getFlagValue } from '../../redux/actions/flagsmith/flagsmith-main';
import { CLOSE_HEAVY_ICON, DOCUMENT_ID_ICON, INSTAREM_NIUM_FOREX_LOGO_ICON } from '@Images';

const ServiceUnavailableContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 528px;
  min-height: 494px;
  padding: 16px 32px 32px 32px;
  border-radius: 10px;
  background: ${COLORS.white};
  .close-icon {
    float: right;
    align-self: flex-end;
    justify-self: flex-end;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .announcement-icon {
    margin-top: 22px;
    width: 230px;
    height: 64px;
  }
  .header {
    font-size: 20px;
    margin: 20px 0 12px 0;
    font-weight: 700;
    text-align: center;
    line-height: 24px;
  }
  .message-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 24px;
    letter-spacing: 0px;
    text-align: center;
    .company-name {
      font-weight: 700;
    }
    .show-more {
      font-weight: 700;
      color: ${COLORS.brandPrimary};
    }
  }
  .how-it-works-container {
    width: 358px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgba(72, 250, 255, 0.1);
    color: ${COLORS.black};
    padding: 12px 16px;
    border: 1px solid ${COLORS.dividerBlue};
    gap: 12px;
    border-radius: 8px;
    .header-container {
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      img {
        margin-right: 8px;
      }
    }
    .process-list-container {
      font-size: 12px;
      margin-left: 12px;
      .list {
        list-style: disc;
        .list-item {
          margin: 4px 0;
        }
      }
    }
  }
  .nium-forex-image-text {
    height: 40px;
    width: 100px;
    margin-bottom: 8px;
  }
  .divider {
    width: 464px;
    height: 0px;
    margin: 32px 0;
    /* Light/Gray/200 */
    border: 1px solid ${COLORS.lightGrey};
  }
  .link-button {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 219px;
    height: 46px;
    text-align: center;
    text-decoration: none;
    color: ${COLORS.textGrey};
    outline: none;
    border: none;
    border-radius: 4px;
    background-color: ${COLORS.dividerBlue};

    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0px;
  }
  .logout-button {
    margin-top: 16px;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    color: ${COLORS.brandPrimary};
    cursor: pointer;
  }
  @media ${DEVICES.mobileL} {
    width: 300px;
  }
`;

function ServiceUnavailable({ status, onClose, logoutRequest }) {
  const navigate = useNavigate();
  const showLearnMoreLink = getFlagValue(FOREX_ALLOWED_PIN_CODES)?.showLearnMore || {
    enabled: false
  };
  const [handleCTA, setHandleCTA] = useState(false);
  const isUnApprovedUser = status.includes(INITIATED) || status.includes(REGISTERED);

  useEffect(() => {
    if (checkForMobileWebView()) setHandleCTA(false);
    else if (status) {
      setHandleCTA(isUnApprovedUser);
    }
    // eslint-disable-next-line
  }, []);

  const checkForMobileWebView = () => {
    // for react-native web view hide logout option
    if (window?.ReactNativeWebView || window?.WebViewBridge) {
      return true;
    }
    return false;
  };

  const handleLogout = async (onClose) => {
    const response = await logoutRequest();
    if (response && response.data && response?.data?.success) {
      onClose(true);
      /**
       * This is an interim fix for issue of multiple popups due to multiple api calls
       * A more thoughtful and better fix will be implemented soon
       * We'll select the modal component by classname and remove visible class from
       * the classlist of children of selected elements
       *
       */
      const modals = document.getElementsByClassName('modal');
      if (modals.length > 0) {
        let modalChildren = [];
        for (let i = 0; i < modals.length; i++) {
          modalChildren.push(modals[i].getElementsByClassName('visible')[0]);
        }
        modalChildren = modalChildren.filter((x) => !!x);
        for (let i = 0; i < modalChildren.length; i++) {
          modalChildren[i].classList.remove('visible');
        }
      }
      navigate(POST_LOGOUT_URL);
    }
  };
  return (
    <ServiceUnavailableContainer>
      {!isUnApprovedUser && (
        <img
          alt="close"
          className="close-icon"
          src={CLOSE_HEAVY_ICON}
          onClick={() => onClose(false)}
        />
      )}
      <img alt="announcement" className="announcement-icon" src={INSTAREM_NIUM_FOREX_LOGO_ICON} />
      <span className="header">{SERVICE_UNAVAILABLE_MODAL_TEXT.header}</span>
      <span className="message-text">
        {SERVICE_UNAVAILABLE_MODAL_TEXT.introText} <span className="company-name">Nium Forex</span>.
      </span>

      <span className="message-text">
        {SERVICE_UNAVAILABLE_MODAL_TEXT.descText}
        {showLearnMoreLink.enabled && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={showLearnMoreLink.href}
            className="show-more"
          >
            Learn More
          </a>
        )}
      </span>
      <div className="how-it-works-container">
        <div className="header-container">
          <img alt="document" src={DOCUMENT_ID_ICON} />
          <span>How it works:</span>
        </div>
        <div className="process-list-container">
          <ul className="list">
            <li className="list-item">Share your personal and recipient details.</li>
            <li className="list-item">Check and lock in the FX rates.</li>
            <li className="list-item">Done! Nium Forex team will reach out to you.</li>
          </ul>
        </div>
      </div>
      <a
        className="link-button"
        href={NIUM_FOREX_URL_SEND_MONEY}
        target="_blank"
        rel="noreferrer noopener"
      >
        Get started
      </a>
      {handleCTA && (
        <span className="logout-button" onClick={() => handleLogout(onClose)}>
          Log out
        </span>
      )}
    </ServiceUnavailableContainer>
  );
}
ServiceUnavailable.propTypes = {
  onClose: PropTypes.any,
  status: PropTypes.string,
  logoutRequest: PropTypes.any
};
const mapStateToProps = (reduxState) => {
  const {
    rootReducer: {
      userStatusReducer: { status }
    }
  } = reduxState;

  return { status };
};

export default connect(mapStateToProps, { logoutRequest })(ServiceUnavailable);
